export default __webpack_public_path__ + "static/media/bondora.718827d1.png";